import PAYMENT_TERMS from '~/constants/payment-terms'

function getTermCalculationMultiplier (term: string): number {
  switch (term) {
    case PAYMENT_TERMS.MONTHLY:
      return 12
    case PAYMENT_TERMS.QUARTERLY:
      return 4
    case PAYMENT_TERMS.QUINQUENNIALLY:
      // multiply on 0.25, because we give a 20% discount if people pay quinquennially
      return 0.25
    case PAYMENT_TERMS.ANNUALLY:
    default:
      return 1
  }
}

export default getTermCalculationMultiplier
